/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
// import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import useAPIError from '../../../hooks/useAPIError';
import { useAuthStore } from '../../../store/AuthContext';
// import { useAppStore } from '../../store/AppContext';
import TarjetaService from '../../../services/TarjetaService';
import clubTarjeta from '../../../assets/images/club-tarjeta-caprabo.png';
import TarjetaTemporalSolicitarTarjeta from '../commons/TarjetaTemporalSolicitarTarjeta';

interface Props {
  cardNumberLong: string | undefined;
  load: boolean;
}
const AdicionalCaprabo: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { cardNumberLong, load } = props;
  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              {' '}
              <section className="section header-tarjetas tarjetas">
                <div className="container">
                  <div className="header-tarjetas__content">
                    <h1 className="header-tarjetas__title">
                      {t('tarjetas.tarjeta-socio.title')}
                    </h1>
                    <p>
                      {t('caprabo.tarjetas.tarjeta-socio.partner-card')}{' '}
                      <strong>{cardNumberLong}</strong>
                    </p>
                  </div>
                </div>
              </section>
              <section className="o-section--giant__top u-padding-bottom-hero section--background-color tarjetas">
                <div className="container-inner">
                  <div className="img-tarjeta">
                    <img src={clubTarjeta} alt="Tarjeta Club Caprabo" />
                  </div>

                  <div className="tarjeta__content">
                    <h2 className="bloque-datos__title">
                      <span className="divider__square brand-color" />
                      <span className="u-margin-right">
                        {t('tarjetas.tarjeta-socio.caprabo-club')}
                      </span>
                    </h2>
                    <TarjetaTemporalSolicitarTarjeta />
                  </div>
                </div>
              </section>
              {/* <TarjetaForm
                visible={showSolicitud}
                setVisible={setShowSolicitud}
              />
              <AdicionalModal visible={showModal} setVisible={setShowModal} /> */}
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default AdicionalCaprabo;
